<app-stats
  [metricsConfig]="metricsConfig()"
  [gridConfig]="gridConfig()"
  [chartConfig]="chartConfig()"
  [chartData]="chartData()"
  [withDateAggregation]="false"
  [dateAggregation]="dateAggregation()"
  [localStorageKey]="localStorageKey"
  (metricsSelect)="metricsChanged($event)"
  (dateAggregationChange)="dateAggregationChanged($event)"
  (grid)="grid.set($event)"
  [filters]="filters()"
  (filterChange)="filterChanged($event)"
  (csvExport)="downloadFile()"
/>
